import * as React from "react";
import { forwardRef } from "react";
const SvgSortAsc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 800, height: 800, fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "rgba(255,255,255,0.5)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7 3v18M7 3l4 4M7 3 3 7m11-4h1m-1 6h3m-3 6h5m-5 6h7" }));
const ForwardRef = forwardRef(SvgSortAsc);
export { ForwardRef as ReactComponent };
